/* eslint-disable no-plusplus */

const addLineInCode = (code) => {
  const formatCode = code.split('\n');
  let count = 1;
  for (let index = 0; index < formatCode.length; index++) {
    if (formatCode[index].length > 63) {
      count++;
    }
  }
  return code.concat(Array(count + 3).fill('\n').join(''));
};

const addTabsInCode = (code, tabsNum = 1) => {
  const formatCode = code.split('\n');
  const tabsString = new Array(tabsNum).fill('\t').join('');
  return formatCode.map((element) => `${tabsString}${element}`).join('\n');
};

const downloadString = (text, fileName) => {
  if (text) {
    const tempHrefElement = document.createElement('a');
    const file = new Blob([text], { type: 'text/plain' });
    tempHrefElement.href = URL.createObjectURL(file);
    tempHrefElement.download = fileName;

    document.body.appendChild(tempHrefElement);
    tempHrefElement.click();
    tempHrefElement.remove();
  }
};

const isNotEquivalent = (dinamicObject, defaultObject) => {
  const formatObject = {};
  const dinamicProps = Object.getOwnPropertyNames(dinamicObject);

  for (let i = 0; i < dinamicProps.length; i++) {
    const propName = dinamicProps[i];
    if (
      typeof defaultObject[propName] === 'object'
      && Object.keys(defaultObject[propName]).length
    ) {
      const children = isNotEquivalent(dinamicObject[propName], defaultObject[propName]);
      if (Object.keys(children).length && Object.values(children).filter(obj => obj !== '').length) {
        formatObject[propName] = isNotEquivalent(dinamicObject[propName], defaultObject[propName]);
      }
    } else if (dinamicObject[propName] !== defaultObject[propName]) {
      formatObject[propName] = dinamicObject[propName];
    }
  }
  return formatObject;
};

module.exports = {
  addLineInCode,
  isNotEquivalent,
  downloadString,
  addTabsInCode,
};
